import {Component, EventEmitter, Output} from '@angular/core';
import {NgClass, NgForOf, NgIf, NgStyle} from "@angular/common";
import {RouterLink} from "@angular/router";
import {ApplicationProcessModule} from "../application-process/application-process.module";

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [
        NgIf,
        NgForOf,
        RouterLink,
        NgClass,
        RouterLink,
        NgForOf,
        NgStyle,
        ApplicationProcessModule,
    ],
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent {
    isModalVisible = false;
    isModalOpen = false;
    programImages = [
        {
            'img': 'assets/image/home-1.webp',
            'title': 'Bachelor of Accounting & Finance',
            'learnMoreUrl': '/programs/bachelor-of-accounting-and-finance',
        },
        {
            'img': 'assets/image/home-2.webp',
            'title': 'Bachelor of Hospitality & Tourism',
            'learnMoreUrl': '/programs/bachelor-of-hospitality-and-tourism',
        },
        {
            'img': 'assets/image/home-3.webp',
            'title': 'Bachelor\'s in Cybersecurity',
            'learnMoreUrl': '/programs/bachelor-in-cybersecurity',
        },
        {
            'img': 'assets/image/home-4.webp',
            'title': 'Master\'s in Cybersecurity',
            'learnMoreUrl': '/programs/master-in-cybersecurity',
        },
        {
            'img': 'assets/image/home-5.webp',
            'title': 'Bachelor\'s in Data Science',
            'learnMoreUrl': '/programs/bachelor-in-data-science',
        },
        {
            'img': 'assets/image/home-6.webp',
            'title': 'Master\'s in Data Science',
            'learnMoreUrl': '/programs/master-in-data-science',
        },
        {
            'img': 'assets/image/home-7.webp',
            'title': 'Master\'s in Information Technology',
            'learnMoreUrl': '/programs/master-in-information-technology'
        },
        {
            'img': 'assets/image/home-8.webp',
            'title': 'Ph.D. in Education',
            'learnMoreUrl': '/programs/phd-in-education',
        }

    ]
    learning = [
        {
            'icon': 'fa-solid fa-laptop',
            'title': 'Online Degree Program',
            'content': 'PAIU offers online degrees in the India, designed to give students flexibility without compromising quality. Whether you\'re interested in an Online Bachelor\'s Degree or a specialized Online Master\'s Degree, we offer accredited programs that cater to your needs.',
        },
        {
            'icon': 'fa-solid fa-piggy-bank',
            'title': 'Demanding Degree Program',
            'content': 'Pursue a Bachelor\'s, Master\'s Degree in Accounting &amp; Finance, Cybersecurity, or  Hospitality Management, we have the right program for you. For advanced education, join Data Science, and  Information Technology.',
        },
        {
            'icon': 'fa-solid fa-earth-americas',
            'title': 'Accredited International Degree',
            'content': 'We have the French Ministry of Higher Education as our affiliation, which guarantees that our programs are of the highest quality globally. Join us for an education that\'s not just recognized but accepted by employers and institutions worldwide.',
        },
        {
            'icon': 'fa-regular fa-clock',
            'title': 'Fast-track Options',
            'content': 'Flexible study solutions are made to work with your busy schedule, so you can keep moving forward in your profession. With Paris American International University, you may learn at your own schedule.\n',
        },
        {
            'icon': 'fa-solid fa-chalkboard-user',
            'title': 'Suitable for Working Professionals',
            'content': 'Programs are ideal for those balance work and study. We understand the challenges professionals face and have designed flexible programs, our Online Bachelor\'s ,  master\'s, to fit the busy schedules.',
        },
        {
            'icon': 'fa-solid fa-globe',
            'title': 'Beyond Borders',
            'content': 'Earn an esteemed online degree from a top university while networking with global peers in webinar classes. Forge friendships worldwide, cultivating a valuable network for career advancement and enhanced opportunities.',
        },

    ]
    activeTab = 0;
    tabs = [
        {
            label: 'Undergraduate Students',
            content: 'Our Undergraduate Degree Programs are designed to give students a solid foundation in their chosen field of study. With a variety of programs available, including Bachelor’s Degrees in Accounting & Finance, Bachelors in Cybersecurity, Bachelor in Hospitality Management, and Bachelor of Information Technology, we prepare our students for global careers.'
        },
        {
            label: 'Postgraduates Aspirants',
            content: 'For those looking to enhance their expertise, our Postgraduate Degrees provide advanced knowledge and skills. Programs like Master in Cyber Security, Masters in Data Science, and Masters of Information Technology are crafted to meet the growing demand for professionals in these high-demand sectors'
        },
        {
            label: 'Degree for Working Professional',
            content: 'At PAIU, we understand the challenges working professionals face when balancing career and education. We specifically built our programs with flexibility in mind.Whether you’re pursuing an Online BBA Degree or an Online MBA in the India, our degrees allow you to study at your own pace while continuing to work.'
        },
        {
            label: 'College Drop-outs',
            content: 'A second chance for those who wish to study. Our courses have the goal to assist you in getting back on track while earning a degree that recognizes your prior education.You can always start over and achieve your goals at any point.'
        },
        {
            label: 'Credit Transferring',
            content: 'If you’ve already completed courses at another recognized institution, you may be eligible to transfer those credits toward your degree at PAIU. This helps you save time, avoid repeating courses, and fast-track your path to graduation.'
        },
    ];

    currentIndex = 0;
    slides = [
        {
            title: 'Globally Recognized  Accreditations  from the ministry of higher education france',
            description: 'Our degree programs are fully accredited and recognized by the ministry of higher education France',
            imgSrc: 'assets/img/banner/hero-img-3.webp.bv_resized_desktop.webp.bv.webp'
        },
        {
            title: 'Flexible Online Education for Working Professionals',
            description: 'The convenience of online learning make your learning effortless.',
            imgSrc: 'assets/img/banner/paiu-hero-1.png'
        },
        {
            title: 'Online Bachelor’s Degree with International Accreditation',
            description: 'Globally recognized bachelor’s degree programs with flexible, high-quality education for students worldwide.',
            imgSrc: 'assets/img/banner/web-banners-10-1.png'
        },
        {
            title: 'Accelerate Career with Online Master’s Degree',
            description: ' Accredited online master’s degree programs tailored for working professionals',
            imgSrc: 'assets/img/banner/web-banners-11-1.png'
        },
        {
            title: 'Flexible Online Education for Working Professionals',
            description: 'The convenience of online learning make your learning effortless.',
            imgSrc: 'assets/img/banner/web-banners-12-1.png'
        }
    ];


    accordionItems = [
        {
            title: 'Frequently Asked Questions',
            content: 'We offer a wide variety of programs including Undergraduate Degree Programs, Postgraduate Courses in the India, and specialized degrees for working professionals. Our programs include Bachelor’s Degrees in fields like Accounting & Finance, Cybersecurity, Information Technology, Data Science, and Hospitality Management, as well as Master’s Degrees in Cyber Security, Data Science, and Information Technology.',
            open: false
        },
        {
            title: 'Are PAIU\'s programs internationally recognized?',
            content: 'Yes, PAIU’s programs are recognized by the French Ministry of Higher Education, ensuring that our graduates receive globally accredited degrees.\n',
            open: false
        },
        {
            title: 'Can I work while studying at PAIU?',
            content: 'Absolutely. Our flexible online programs are designed for working professionals, allowing you to balance your job and studies effectively.\n',
            open: false
        },
        {
            title: 'What is the admission process for international students?',
            content: 'International students can easily apply online. We offer guidance through each step, ensuring that all necessary documentation is provided for a seamless admission process.',
            open: false
        },
        {
            title: 'Do I need to attend classes in person?',
            content: 'No, all of our degree programs, including Bachelor’s and Master’s, are available fully online, allowing you to learn from anywhere in the world.',
            open: false
        },
        {
            title: 'What careers can I pursue with a PAIU degree?',
            content: 'PAIU graduates pursue careers in various high-demand fields, such as Cybersecurity, Data Science, Finance, IT Management, and Hospitality, among others. Our degrees are tailored to give you the skills necessary to thrive in today’s job market.',
            open: false
        },
        {
            title: 'What makes PAIU different from other universities?',
            content: 'PAIU offers a unique combination of international recognition and flexible online programs. Our degrees are accredited by the French Ministry of Higher Education, providing global recognition. Additionally, our online degrees give students the flexibility to study from anywhere in the world while still receiving a top-tier education.',
            open: false
        }, {
            title: 'Are your programs suitable for working professionals?',
            content: 'Absolutely. Our programs are specifically designed for working professionals. With flexible online learning, you can complete your degree at your own pace, making it easier to balance work and study.\n' +
                '\n',
            open: false
        }, {
            title: 'What support services are available to students?',
            content: 'We provide a wide range of student support services, including academic advising, career counseling, and technical support for our online learning platform. Whether you need help choosing the right course or assistance with your studies, our team is here to help.\n' +
                '\n',
            open: false
        },
        {
            title: 'Do I need prior experience to enroll in a cybersecurity or data science program?',
            content: 'While some foundational knowledge may be helpful, many of our programs, such as the Bachelor\'s in Cybersecurity or Master’s in Data Science, are designed to accommodate students from various backgrounds. We offer a comprehensive curriculum that builds from the basics to more advanced topics.\n' +
                '\n',
            open: false
        },
        {
            title: 'What career opportunities are available to PAIU graduates?',
            content: 'Graduates from PAIU pursue careers in a wide variety of industries. Our programs prepare students for roles in fields such as accounting and finance, cybersecurity, data science, hospitality management, information technology, and more. Our graduates are equipped with the skills to thrive in today\'s competitive job market.\n' +
                '\n',
            open: false
        },


    ];



    ngOnInit(): void {
        // setTimeout(() => {
        //     this.openModal();
        // }, 5000);
    }

    selectTab(index: number): void {
        this.activeTab = index;
    }

    nextSlide() {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    }

    toggleAccordion(index: number): void {
        this.accordionItems[index].open = !this.accordionItems[index].open;
    }



}
